import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';

const ChevronRight = require('react-icons/lib/md/chevron-right');

import {BEITRAG_ERSTES_KIND, BEITRAG_GEWSCHISTERKINDER} from "../../constants";

const contentStyle = {
  margin: 20,
  textAlign: 'left',
  display: 'inline-block',
};

class WelcomeForm extends Component {
  render() {
    const {onNext, viewportWidth} = this.props;

    return (
      <div>
        <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
        <div className="text" style={contentStyle}>
          Willkommen zur Ratzgiwatz Jugendprogramm Web-Anmeldung.
          <br/><br/>
          Mit diesem Formular k&ouml;nnen Sie Ihre Kinder verbindlich f&uuml;r die Aktionen des Jugendprogramms von
          Ratzgiwatz anmelden.
          <br/><br/>
          Die Anmeldung erfolgt in mehreren Schritten:
          <ol>
            <li>
              Geben Sie bitte zun&auml;chst Ihre Kontaktdaten als Erziehungsberechtigter an.
            </li>
            <li>
              Danach k&ouml;nnen Sie Ihr Kind oder mehrere bei Ihnen wohnende Kinder anmelden.
              <br/>
              In diesem Schritt geben Sie bitte jeweils die Aktionen an, zu denen Sie ihr Kind anmelden wollen.
            </li>
            <li>
              Abschlie&szlig;end senden wir Ihnen eine E-Mail mit einem Best&auml;tigungslink zu.
              <br/>
              <strong>
                Erst nach Best&auml;tigung des Links in der Mail ist Ihre Anmeldung vollst&auml;ndig.
              </strong>
              <br/>
              Achten Sie daher bitte auf die <b>korrekte Eingabe Ihrer E-Mail-Adresse</b>.
            </li>
          </ol>
          Die Beitr&auml;ge f&uuml;r die jeweiligen Aktionen entnehmen Sie bitte dem <a target="_blank" href="http://www.ratzgiwatz.de/jugendprogramm/">Programm.</a>
          <br/><br/>
          Wir wollen, dass alle Kinder an Ratzgiwatz teilnehmen können. Falls der Beitrag zu hoch für Sie sein sollte,
          sprechen Sie uns bitte an. Wir finden eine Lösung.
        </div>
        <br/>
        <RaisedButton
          label={viewportWidth > 400 ? "Verbindliche Anmeldung starten." : "Los gehts"}
          primary={true}
          icon={<ChevronRight/>}
          onTouchTap={onNext}
        />
      </div>
    );
  }
}

export default WelcomeForm



// WEBPACK FOOTER //
// ./src/components/welcome/WelcomeForm.jsx